import { render, staticRenderFns } from "./Supperclubs.vue?vue&type=template&id=cb7b485a"
import script from "./Supperclubs.vue?vue&type=script&lang=js"
export * from "./Supperclubs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports